
<body class="horizontal-layout horizontal-menu 1-column  bg-full-screen-image blank-page blank-page" data-open="hover" data-menu="horizontal-menu" data-col="1-column">
  <!-- BEGIN: Content-->
  <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="content-wrapper">
          <div class="content-header row">
          </div>
          <div class="content-body">
              <section class="row flexbox-container">
                  <div class="col-12 d-flex align-items-center justify-content-center">
                      <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
                          <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
                              <div class="card-header border-0 pb-0">
                                  <div class="card-title text-center">
                                      <img src="/assets/images/logo-dark.png" alt="branding logo">
                                      <br><br>
                                  </div>
                              </div>
                              <div class="card-content">
                                  <p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1">
                                  <span>Set Your Account Credentials</span></p>
                                  <div class="card-body">
                                      <form class="form-horizontal">
                                          <fieldset class="form-group position-relative has-icon-left mb-0">
                                              <input type="password" class="form-control" id="user-password" minlength="8" placeholder="Enter Password"
                                              [(ngModel)]="password" name="password" #Password="ngModel" required>
                                              <div class="form-control-position">
                                                  <i class="fa fa-key"></i>
                                              </div>
                                              <span class="text-danger"
                                                  *ngIf="(Password.errors && Password.errors['minlength'] || Password.invalid) && Password.touched">*
                                                  Password
                                                  must be at least 8 characters long.
                                              </span>
                                          </fieldset>
                                          <fieldset class="form-group position-relative has-icon-left">
                                              <input type="password" class="form-control" id="user-password-2" minlength="8" placeholder="Enter Confirm Password"
                                              [(ngModel)]="confirmPassword" name="confirmPassword" #ConfirmPassword="ngModel" required>
                                              <div class="form-control-position">
                                                  <i class="fa fa-key"></i>
                                              </div>
                                          </fieldset>
                                          <button type="submit" class="btn btn-outline-primary btn-block" (click)="Submit()" [disabled]="!password || !confirmPassword">
                                              <i class="feather icon-lock mr-1"></i>
                                              Reset Password
                                          </button>

                                          <div class="form-group row mt-2">
                                              <div class="col-sm-6 col-12 text-center text-sm-left pr-0">
                                                  <a href="javascript:void(0)" [routerLink]="['/signup']" class="card-link">New Account</a>
                                              </div>
                                              <div class="col-sm-6 col-12 float-sm-left text-center text-sm-right">
                                                  <a href="javascript:void(0)" [routerLink]="['/signin']" class="card-link">Signin</a>
                                              </div>
                                          </div>
                                      </form>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </section>
          </div>
      </div>
  </div>
  <!-- END: Content-->

</body>
